import React from 'react';

import { string, shape } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';
import Icon from '../../icon/Icon';

import './LoadingSpinner.scss';

const sizeList = {
  xsmall: 'xs',
  small: 'sm',
  default: 'default',
  medium: 'md',
  large: 'lg',
  xlarge: 'xl',
  xxlarge: 'xxl'
};

/**
 * @deprecated
 */
export default class LoadingSpinner extends BaseComponent {
  render() {
    const { color, size, className, style } = this.props;

    const icon = 'spinner';

    const classNames = ClassNames('LoadingSpinner', className, color);

    return (
      <Icon
        style={style}
        className={classNames}
        icon={icon}
        size={sizeList[size]}
        spin
      />
    );
  }
}

LoadingSpinner.propTypes = {
  color: string,
  size: string,
  className: string,
  style: shape({})
};

LoadingSpinner.defaultProps = {
  color: 'default',
  size: 'default',
  className: undefined,
  style: {}
};
